<template>
  <el-dialog class="password" title="修改密码" center :visible.sync="dialogVisible" width="480px" :close-on-click-modal="false">
    <el-form   :model="passwordForm" ref="passwordForm" size="small" label-width="auto" :rules="rules" label-position="right">
      <el-form-item label="新密码" prop="password">
        <el-input v-model.trim="passwordForm.password" type="password" placeholder="请输入新密码" show-password autocomplete="off" />
      </el-form-item>
    </el-form>
    <div class="text-align-center">
      <el-button type="info" plain size="small" @click="dialogVisible=false">取消</el-button>
      <el-button type="primary" size="small" @click="confirmPasswordChange">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      dialogVisible: false,
      passwordForm: {
        password: '',//新密码
      },
      rules: {
        password: [
          { min: 6, max: 18, message: "用户密码长度必须介于 6 和 18 之间", trigger: "blur" }
        ],
      },
    };
  },
    computed: {
    ...mapState({
      userInfo: state => state.userInfo
    }),
  },
  methods: {
    init() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.passwordForm.resetFields();
      })
    },
    // 确认修改密码
    confirmPasswordChange() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          this.$user.updatePassword({
            ...this.passwordForm,
            id:this.userInfo.id
          }).then(({ data }) => {
            if (data.code == 200) {
              this.$message({
                message: data.message,
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.dialogVisible = false
                }
              })
            } else {
              this.$message.error(data.message)
            }
          })
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.password{
    line-height: normal;
}
</style>
